import { Link } from '@inertiajs/react'
import { Anchor, Breadcrumbs, Container, Group, Stack, Text, Title } from '@mantine/core'
import type { ComponentProps, ReactNode } from 'react'
import FlashMessages from '@/components/FlashMessages'
import type { FlashData } from '@/types'

type BreadcrumbItem = {
  label: string
  href?: string
}

type PageLayoutProps = {
  title: string
  breadcrumbs?: BreadcrumbItem[]
  subtitle?: ReactNode
  actions?: ReactNode
  flash?: FlashData
  size?: ComponentProps<typeof Container>['size']
  children: ReactNode
}

export default function PageLayout({
  title,
  breadcrumbs = [],
  subtitle,
  actions,
  flash,
  size = 'lg',
  children,
}: PageLayoutProps) {
  return (
    <Container size={size} py="md">
      <Stack gap="lg">
        <Group justify="space-between" align="flex-start" wrap="nowrap">
          <Stack gap={4}>
            {breadcrumbs.length > 0 ? (
              <Breadcrumbs separator="/">
                {breadcrumbs.map((item, index) =>
                  item.href ? (
                    <Anchor key={`${item.label}-${index}`} component={Link} href={item.href} c="dimmed" size="sm">
                      {item.label}
                    </Anchor>
                  ) : (
                    <Text key={`${item.label}-${index}`} c="dimmed" size="sm">
                      {item.label}
                    </Text>
                  )
                )}
              </Breadcrumbs>
            ) : null}
            <Title order={2}>{title}</Title>
            {subtitle ? (
              <Text c="dimmed" size="sm">
                {subtitle}
              </Text>
            ) : null}
          </Stack>
          {actions ? (
            <Group gap="sm" wrap="wrap" justify="flex-end">
              {actions}
            </Group>
          ) : null}
        </Group>

        <FlashMessages flash={flash} />
        {children}
      </Stack>
    </Container>
  )
}
